import { JOURNEY_VIEWER } from '../../constants/actionTypes';

const initialState = {
  loading: true,
  error: null,
  assignment: {},
  metadata: {},
  ui: {
    previewing: false,
  },
};

const journeyViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOURNEY_VIEWER.REQUEST_CONTENTS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };

    default:
      return { ...state, ...initialState };
  }
};

export default journeyViewerReducer;
